import type {
  ClassroomTeacherEnrollment,
  TeacherEnrollment,
} from '../enrollment';

type TeacherClassroom = {
  id: string;
  name: string;
  courseId: string;
  courseName: string;
  courseOrder: number;
  icon: number;
  teacherEnrollments?: ClassroomTeacherEnrollment[];
};

type TeacherBase = {
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  email: string;
  type?: string | null;
  roles?: string[] | null;
  lastLogin?: string | null;
  reportsEnabled?: boolean | null;
  isInvitation?: boolean | null;
  isSchoolInvitation?: boolean | null;
  token?: string | null;
  expiresAt?: string | null;
  source?: { id?: string | null; name?: string | null } | null;
};

type ClassroomTeacher = TeacherBase & {
  classroomEnrollment?: TeacherEnrollment | null;
};

type OrganizationTeacher = TeacherBase & {
  classrooms?: TeacherClassroom[] | null;
};

const isTeacherCreatedManually = (teacher: TeacherBase): boolean => {
  return !teacher.source?.id;
};

export { isTeacherCreatedManually };

export type {
  ClassroomTeacher,
  OrganizationTeacher,
  TeacherBase,
  TeacherClassroom,
  TeacherEnrollment,
};
